<template>
  <div class="contestant" :class="{'expanded': expanded}">

    <div class="contestant-top-row">
      <span class="contestant-name">
        <ProfilePicture :user="contestant" :size="20"></ProfilePicture> <ProfileName :user="contestant"></ProfileName>
      </span>

      <span class="float-right" @click="expanded = !expanded">
        <span class="contestant-score">
          {{contestant.displayScore ?? contestant.score}}
        </span>
        <span class="expand-button">
          <i class="fa" :class="expanded? 'fa-caret-up' : 'fa-caret-down'" aria-hidden="true"></i>
        </span>
      </span>
    </div>

    <div v-if="expanded" class="contestant-score-details">
      <div v-for="(details, index) in contestant.pointJustifications" :key="contestant._id + '-' + index" class="score-details-row">
        {{details}}
      </div>
    </div>
  </div>
</template>


<script>
import ProfilePicture from "@/components/profile/ProfilePicture.vue";
import ProfileName from "@/components/profile/ProfileName.vue";

export default {
  name: "OscarPoolContestantScore",
  components: {ProfileName, ProfilePicture},
  props: ['contestant', 'show_score_details'],

  data() {
    return {
      expanded: false,
    }
  },
  computed: {
/*
    expanded() {
      return this.show_score_details;
    },
*/
  },
  methods: {

  }
}
</script>


<style scoped>

.contestant {
  position: relative;
  padding: 0.1em 0.5em 0.5em 0.3em;

  height:2.25em;

  border-style: solid;
  border-width: 0.1px;
  border-radius: 5px;
  border-color: transparent;

  transition: height 0.2s ease-out, border-color 0.5s ease-out;

  .float-right {
    float: right;

    .contestant-score {
      font-weight: 500;
    }

    .expand-button {
      display: inline-block;

      margin-top: -5px;
      padding-left: 5px;
      color: rgba(0, 0, 0, 0.175);
    }

    &:hover {

      cursor: pointer;

      .contestant-score {
        font-weight: 700;
      }
      .expand-button {
        color: dimgrey;
      }
    }
  }

  &.expanded {
    /*height: 15em;*/
    height: fit-content;
    /*
    border-style: solid;
    border-width: 0.1px;
    border-radius: 5px;
    border-color: var(--bs-card-border-color);
    margin-top: 5px;
    margin-bottom: 5px;
    */


    .contestant-score-details {
      /*text-align: right;*/
      font-size: x-small;
      margin-top: 0.375em;
      margin-left: 20px;

      /*margin-right: 10px;*/
      width: fit-content;

      .score-details-row {
        width: fit-content;
      }
    }
  }
}

</style>